export default "__VITE_ASSET__D4U$h8s7__"